import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import logo from './images/circet_logo.png';
import { BASEURL } from './constant';
import postApi from './api/postApi';
import { login as authLogin } from './auth';
import MapChart from "./components/charts/MapChart";

const importAll = (r: any) => r.keys().map(r);

const images = importAll((require as any).context('./Event logo', false, /\.(png|jpg)$/));

const testimonials = [
  { type: 'quote', text: 'I wanted to take a moment to thank you for your recent work in monitoring/optimizing our network. This event was a highly anticipated one which T-Mobile prepared for over many months with significant network investment. We needed to have our network perform at the highest level and your team was instrumental in helping us do that on each of the three days.', author: 'RF Manager' },
  { type: 'quote', text: 'I am very impressed with the level of commitment, support, preparation, and execution for this event. FES has done a great job throughout the event. FES was consistent in his update, capturing issues live and taking action to re-adjust accordingly. We truly appreciate this partnership and look forward to future opportunities.', author: 'RF Manager' },
];



const carouselItems = [
  ...images.map((src: string) => ({ type: 'image', src })),
  ...testimonials,
  {type: 'map', title: 'Market Presence'},
];

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);
  const [carouselIndex, setCarouselIndex] = useState(0);
  const [hovered, setHovered] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  const navigate = useNavigate();

  useEffect(() => {
  const token = localStorage.getItem('accessToken');
  if (token) {
    navigate('/home', { replace: true });
  }
}, [navigate]);

  useEffect(() => {
    if (hovered) return;
    const interval = setInterval(() => {
      setCarouselIndex((prev) => (prev + 1) % carouselItems.length);
    }, 4000);
    return () => clearInterval(interval);
  }, [hovered, carouselItems.length]);

  const handleLogin = async () => {
    if (!email || !password) {
      setError('Please enter both email and password');
      return;
    }

    setError('');
    setBusy(true);
    try {
      const res = await postApi(`${BASEURL}/login`, { email: email.toLowerCase(), password });
      if (res?.data?.status_code === 200) {
        authLogin(res.data.data, res.data.access_token);
        navigate('/home', { replace: true });
      } else {
        setError(res?.data?.message || 'Login failed');
      }
    } catch (err: any) {
      setError(err.message || 'Unexpected error');
    } finally {
      setBusy(false);
    }
  };

  

  return (
    <div style={{ background: '#fff', minHeight: '100vh' }}>
      <div className="d-flex vh-100">
        {/* LEFT SIDE */}
        <div className="col-md-5 d-flex flex-column justify-content-center align-items-center p-5 bg-white">
          <img
            src={logo}
            alt="Circet Logo"
            className="img-fluid"
            style={{ maxHeight: '100px', width: 'auto' }}
          />
          <h2 className="mt-3">Welcome to NMaaS</h2>
          <p className="text-muted">Network Monitoring as a Service Tool</p>

          <div className="w-75 mt-4">
            <div className="form-group mb-3">
              <label>Email</label>
              <input
                type="email"
                className="form-control"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                onKeyDown={(e) => e.key === 'Enter' && handleLogin()}
              />
            </div>
            <div className="form-group mb-3">
              <label>Password</label>
              <div style={{ position: 'relative' }}>
                <input
                  type={showPassword ? 'text' : 'password'}
                  className="form-control"
                  placeholder="Enter your password"
                  value={password}
                  onChange={(e) => setPassword(e.target.value)}
                  onKeyDown={(e) => e.key === 'Enter' && handleLogin()}
                  style={{ paddingRight: '45px' }}
                />
                <button
                  type="button"
                  onClick={() => setShowPassword(!showPassword)}
                  className="btn position-absolute bg-transparent border-0 p-0"
                  style={{
                    top: '50%',
                    right: '10px',
                    transform: 'translateY(-50%)',
                    zIndex: 2,
                    cursor: 'pointer',
                  }}
                  tabIndex={-1}
                >
                  <i className={`bi ${showPassword ? 'bi-eye' : 'bi-eye-slash'} fs-5 text-secondary`}></i>
                </button>
              </div>
            </div>

            <div className="d-flex justify-content-between align-items-center mb-3">
              <div className="form-check">
                <input className="form-check-input" type="checkbox" id="rememberMe" />
                <label className="form-check-label" htmlFor="rememberMe">
                  Remember me
                </label>
              </div>
              {/* <a href="#" className="text-primary">Forgot Password?</a> */}
            </div>

            {error && <div className="alert alert-danger">{error}</div>}

            <button
              className="btn btn-dark w-100"
              onClick={handleLogin}
              disabled={busy}
            >
              {busy ? 'Logging in...' : 'Login'}
            </button>

            {/* <div className="text-center mt-3">
              <small>Don't have an account? <a href="#">Sign up</a></small>
              <br />
              <small className="text-muted">Have more questions? <a href="#">Contact Us</a></small>
            </div> */}
          </div>
        </div>

        {/* RIGHT SIDE */}
        <div className="col-md-7 d-none d-md-flex justify-content-center align-items-center"
          style={{
            background: 'linear-gradient(135deg, #ff9966, #ff5e62)',
            borderTopLeftRadius: '2rem',
            borderBottomLeftRadius: '2rem',
            margin: '1rem',
            position: 'relative',
            overflow: 'hidden',
          }}>
      
      {/* Carousel Container */}
          <div className="carousel-wrapper position-relative" 
          style={{
            width: '550px',
            height: '500px',
            overflow: 'hidden',
            position: 'relative',
          }}
          onMouseEnter={() => setHovered(true)}
          onMouseLeave={() => setHovered(false)}
          >
            {carouselItems.map((item, index) => (
              <div
                key={index}
                className={`carousel-slide ${carouselIndex === index ? 'active' : ''}`}
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                  padding: '1.5rem',
                  background: '#fff',
                  borderRadius: '1.5rem',
                  boxShadow: '0 8px 16px rgba(0,0,0,0.2)',
                  transition: 'opacity 0.8s ease-in-out, transform 0.8s ease-in-out',
                  opacity: carouselIndex === index ? 1 : 0.15,
                  zIndex: carouselIndex === index ? 2 : 1,
                  transform: carouselIndex === index ? 'scale(1)' : 'scale(0.9)',
                }}
              >
                {item.type === 'image' ? (
                  <div style={{ height: '100%', width: '100%', display: 'flex', flexDirection: 'column' }}>
                    <div style={{ textAlign: 'center', paddingBottom: '0.5rem' }}>
                      <h5 className="fw-bold text-center text-dark mb-0">Our Populor Events</h5>
                    </div>
                    <div style={{ flex: 1, borderRadius: '1.5rem', overflow: 'hidden' }}>
                      <img
                        src={item.src}
                        alt="Event Logo"
                        className="img-fluid rounded w-100 h-100 object-fit-contain"
                      />
                    </div>
                  </div>
                ) : item.type === 'quote' ? (
                  <div style={{ height: '100%', width: '100%', display: 'flex', flexDirection: 'column' }}>
                    <div style={{ textAlign: 'center', paddingBottom: '0.5rem' }}>
                      <h5 className="fw-bold text-center text-dark mb-0">Our Customer Say</h5>
                    </div>
                    <div style={{ flex: 1, borderRadius: '1.5rem', overflow: 'hidden' }}>
                      <p className="fs-5 text-dark">"{item.text}"</p>
                      <p className="text-muted small">- {item.author}</p>
                    </div>
                  </div>
                ) : item.type === 'map' ? (
                  <div style={{ height: '100%', width: '100%', display: 'flex', flexDirection: 'column' }}>
                    <div style={{ textAlign: 'center', paddingBottom: '0.5rem' }}>
                      <h5 className="fw-bold mb-0 text-dark">Our Presence</h5>
                    </div>
                    <div style={{ flex: 1, borderRadius: '1.5rem', overflow: 'hidden' }}>
                      <MapChart />
                    </div>
                  </div>
                ): null}
              </div>
            ))}
            <div
              className="position-absolute bottom-0 start-50 translate-middle-x d-flex gap-2 pb-3"
              style={{ zIndex: 3 }}
            >
              {carouselItems.map((_, idx) => (
                <div
                  key={idx}
                  onClick={() => setCarouselIndex(idx)}
                  style={{
                    width: carouselIndex === idx ? '14px' : '10px',
                    height: carouselIndex === idx ? '14px' : '10px',
                    borderRadius: '50%',
                    backgroundColor: carouselIndex === idx ? '#ff5e62' : '#ccc',
                    cursor: 'pointer',
                    transition: 'all 0.3s ease',
                  }}
                />
              ))}
            </div>
            

          </div>

          {/* <div className="position-absolute top-0 end-0 p-3">
            <a href="#" className="text-white text-decoration-none fw-bold">About Us</a>
          </div> */}
        </div>
      </div>
    </div>  
  );
}
